var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{on:{"click":function($event){$event.preventDefault();return _vm.sortBy(_vm.sortField)}}},[(_vm.sort)?[(_vm.sort == 'desc')?_c('i',{staticClass:"fas fa-angle-down"}):_c('i',{staticClass:"fas fa-angle-up"})]:_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22d43ae4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Tables/ThSortField.vue
// module id = null
// module chunks = 